<template>
  <div>
    <h6>hell World</h6>
    <p>
      For a guide and recipes on how to configure / customize this project,<br />
      check out the
      <a href="https://cli.vuejs.org" target="_blank" rel="noopener"
        >vue-cli documentation</a
      >.
    </p>
    <button @click="connectWallet()">Connect Wallet</button>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  components: {},
  props: {
    address: String,
    balance: Number,
  },
  data() {
    return {};
  },
  methods: {
    connectWallet: function () {
      this.$emit("connect-wallet");
    },
  },
  mounted() {},
};
</script>